<section class="home">
  <layout-navbar
    [currentFlow]="currentFlow$ | async"
    [currentRoute]="currentRoute$ | async"
    (clickMenu)="onReceiveClickEvent($event)"
  ></layout-navbar>
  <layout-toggle-menu-mobile
    [clickMenu]="openMenu$ | async"
    (closeMenu)="onCloseMenu($event)"
  ></layout-toggle-menu-mobile>
  <div class="home__content max-width-box">
    <router-outlet></router-outlet>
  </div>
  <div class="home__footer">
    <layout-footer-base-home></layout-footer-base-home>
  </div>
</section>
<layout-modal></layout-modal>
